// Generated by scripts/generate_design_tokens.py from design/tokens/nozzle.tokens.json and design/terminology/glossary.json. Do not edit.
export const glossary = {
  "version": "2.0.0",
  "product": {
    "family": "Nozzle It All",
    "desktop": "Nozzle It All for Desktop",
    "android": "Nozzle It All for Android",
    "web": "Nozzle It All Web",
    "website": "nozzleitall.com",
    "advanced-workspace": "Advanced Workspace",
    "capitalization": "Always 'Nozzle It All' (three capitals, no hyphens). Short form in tight UI: 'Nozzle'. Never 'NIA', 'Nozzleitall' or 'Nozzle-It-All'."
  },
  "terms": {
    "state.offline": {
      "label": "Offline",
      "description": "Nozzle can't reach the printer right now."
    },
    "state.connecting": {
      "label": "Connecting",
      "description": "Nozzle is reaching the printer."
    },
    "state.starting": {
      "label": "Starting up",
      "description": "The printer is reachable but its firmware isn't ready yet."
    },
    "state.ready": {
      "label": "Ready",
      "description": "Idle and ready for a job."
    },
    "state.printing": {
      "label": "Printing",
      "description": "A job is running."
    },
    "state.paused": {
      "label": "Paused",
      "description": "The job is paused and can be resumed."
    },
    "state.finished": {
      "label": "Finished",
      "description": "The last job completed. Ready for the next one."
    },
    "state.cancelled": {
      "label": "Cancelled",
      "description": "The last job was cancelled. Ready for the next one."
    },
    "state.error": {
      "label": "Needs attention",
      "description": "The printer reported a problem. Check it before printing."
    },
    "state.unknown": {
      "label": "Unknown",
      "description": "The printer answered, but Nozzle couldn't understand it. Nothing is assumed."
    },
    "route.lan": {
      "label": "Local network",
      "description": "Connected directly on your home or workshop network."
    },
    "route.private-network": {
      "label": "Private network",
      "description": "Connected through your own private network, such as Tailscale. Nozzle doesn't relay this traffic."
    },
    "route.vendor-cloud": {
      "label": "Maker's cloud",
      "description": "Through the printer maker's own cloud service. Used only by optional support for printers that need it."
    },
    "route.none": {
      "label": "No connection",
      "description": "Nozzle slices for this printer but does not connect to it."
    },
    "family.paxx-u1": {
      "label": "Snapmaker U1 (PAXX)",
      "description": "Snapmaker U1 running PAXX firmware in LAN mode. The flagship integration: works fully offline with no account."
    },
    "family.stock-u1": {
      "label": "Snapmaker U1 (stock)",
      "description": "Snapmaker U1 on Snapmaker's own firmware. Uses optional Stock U1 support for features that need Snapmaker's cloud."
    },
    "family.bambu-lab": {
      "label": "Bambu Lab",
      "description": "Bambu Lab printers in LAN mode. Any Bambu cloud features stay inside optional Bambu support."
    },
    "family.prusa": {
      "label": "Prusa",
      "description": "Prusa printers through PrusaLink on your network. Any Prusa Connect features stay inside optional Prusa support."
    },
    "family.klipper": {
      "label": "Klipper",
      "description": "Other Klipper printers on your network."
    },
    "family.octoprint": {
      "label": "OctoPrint",
      "description": "Printers run by OctoPrint on your network."
    },
    "family.export-only": {
      "label": "Export only",
      "description": "Slice for this printer and save the file; send it yourself by USB, SD card or the printer's own app."
    },
    "action.start": {
      "label": "Start print",
      "confirm": "Start printing"
    },
    "action.pause": {
      "label": "Pause",
      "confirm": "Pause print"
    },
    "action.resume": {
      "label": "Resume",
      "confirm": "Resume print"
    },
    "action.cancel": {
      "label": "Cancel print",
      "confirm": "Cancel print",
      "destructive": true
    },
    "action.heat": {
      "label": "Set temperature",
      "confirm": "Heat"
    },
    "action.home": {
      "label": "Home axes",
      "confirm": "Home"
    },
    "action.move": {
      "label": "Move",
      "confirm": "Move"
    },
    "action.load": {
      "label": "Load material",
      "confirm": "Load"
    },
    "action.unload": {
      "label": "Unload material",
      "confirm": "Unload"
    },
    "action.edit-material": {
      "label": "Set material",
      "confirm": "Save to printer"
    },
    "action.toolchange": {
      "label": "Change toolhead",
      "confirm": "Change toolhead"
    },
    "concept.printer": {
      "label": "Printer",
      "plural": "Printers"
    },
    "concept.project": {
      "label": "Project",
      "plural": "Projects",
      "description": "Models, plates, printer, materials and settings, saved together."
    },
    "concept.plate": {
      "label": "Plate",
      "plural": "Plates",
      "description": "One build plate's worth of objects."
    },
    "concept.model": {
      "label": "Model",
      "plural": "Models"
    },
    "concept.job": {
      "label": "Job",
      "plural": "Jobs",
      "description": "A sliced plate sent to a printer."
    },
    "concept.material": {
      "label": "Material",
      "plural": "Materials",
      "description": "Filament: type, colour and brand. Never 'filament profile' in everyday UI."
    },
    "concept.toolhead": {
      "label": "Toolhead",
      "plural": "Toolheads",
      "description": "Numbered from 1 in the UI."
    },
    "concept.full-spectrum": {
      "label": "Full Spectrum",
      "description": "Mixes the colours loaded in a U1's toolheads to print more colours than you have toolheads."
    },
    "concept.camera": {
      "label": "Camera",
      "plural": "Cameras"
    },
    "concept.slice": {
      "label": "Slice",
      "description": "Turn a plate into instructions the printer can run."
    },
    "concept.preview": {
      "label": "Preview"
    },
    "concept.profile": {
      "label": "Print settings",
      "description": "The saved settings a slice uses. Say 'settings'; avoid 'process preset'."
    },
    "outcome.accepted": {
      "label": "Sent",
      "description": "The printer accepted the command."
    },
    "outcome.rejected": {
      "label": "Not sent",
      "description": "Nothing changed on the printer."
    },
    "outcome.unknown": {
      "label": "Result unknown",
      "description": "The printer didn't confirm. Nozzle checks the printer before letting you try again."
    }
  },
  "explanations": {
    "paxx": "PAXX is the recommended way to use a Snapmaker U1 with Nozzle It All. Everything works on your own network: no Snapmaker account, no cloud and no internet connection needed.",
    "stock-u1": "Printers on Snapmaker's own firmware are supported through optional Stock U1 support. It's only installed and started if you add a Stock U1, and it can use your Snapmaker account for features that stock firmware only offers through Snapmaker's cloud. If it stops working, your PAXX printers aren't affected.",
    "remote-access": "To reach your printer away from home, connect your computer or phone to your own private network, such as Tailscale, and add the printer by its private-network address. Nozzle It All connects to that address directly; it never relays printer traffic through its own servers.",
    "cloud": "Nozzle It All doesn't need an account or a Nozzle cloud service. Your models, projects and printer details stay on your device.",
    "flutter": "Some Stock U1 features come from Snapmaker's own components, which are only loaded if you turn on Stock U1 support.",
    "web-local": "Nozzle It All Web slices in your browser. Your models aren't uploaded anywhere.",
    "multi-vendor": "Nozzle It All works with printers from different makers. What you can do with each printer depends on what it offers over your network; anything a printer can't do simply isn't shown.",
    "export-only": "Every printer with a slicing profile can be used without connecting to it: slice, save and export the file, then send it yourself.",
    "first-printer": "Nozzle It All talks to your printers on your own network: a Snapmaker U1 with PAXX (no account, no cloud), Klipper printers, Prusa printers with PrusaLink, Bambu Lab printers in LAN mode and OctoPrint. No printer yet? You can still prepare and slice for any of 376 printer models."
  },
  "internalWords": [
    "Moonraker",
    "Klippy",
    "Flutter",
    "WebAssembly",
    "WASM",
    "IPC",
    "adapter",
    "MQTT",
    "JSON",
    "gcode_macro",
    "print_task_config",
    "Snapmaker Orca",
    "OrcaSlicer"
  ]
} as const;
export type TermId = keyof typeof glossary.terms;
export const label = (id: TermId): string => glossary.terms[id].label;
export const describe = (id: TermId): string => (glossary.terms[id] as { description?: string }).description ?? '';
